<template>
  <div class="grey lighten-5 d-inline-block">
    <div class="grey lighten-4 pa-2 text-left" v-if="deleteAction || moveAction">
      <v-row class="pa-0 ma-0">
        <v-col class="pa-0 ma-0">
          <v-btn text small @click="$refs.stateFormDialog.open()">
            <v-icon text>add</v-icon>
          </v-btn>
          <v-btn text small @click="$emit('delete',node)" v-if="deleteAction">
            <v-icon text class="red--text">delete</v-icon>
          </v-btn>
        </v-col>
        <v-col class="pa-0 ma-0 text-right" v-if="moveAction">
          <v-btn text small v-if="moveUp" @click="$emit('move',node,-1)">
            <v-icon text>keyboard_arrow_up</v-icon>
          </v-btn>
          <v-btn text small v-if="moveDown" @click="$emit('move',node,1)">
            <v-icon text>keyboard_arrow_down</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <div v-for="(state,j) in node.flowStates" :key="j" class="green lighten-5 ma-2 d-inline-block">
      <div class="pa-1 grey lighten-3">
        <v-btn text small @click="$refs.stateFormDialog.open(state)">
          <v-icon text small>edit</v-icon>
        </v-btn>
        <v-btn text small @click="confirmDelete(state)" v-if="node.flowStates.length > 1">
          <v-icon text class="red--text" small>delete</v-icon>
        </v-btn>
      </div>
      <div class="pa-2">
        <div class="ma-2">
          <v-chip label color="green lighten-4" class="pa-0 pl-2">
            <span>Location</span>
            <v-chip label color="green lighten-3 ml-2">{{state.Location.Name}}</v-chip>
          </v-chip>
        </div>
        <div class="ma-2">
          <v-chip label color="green lighten-4" class="pa-0 pl-2">
            <span>State</span>
            <v-chip label color="green lighten-3 ml-2">{{state.State.Name}}</v-chip>
          </v-chip>
        </div>
        <div class="ma-2">
          <v-chip label color="green lighten-4" class="pa-0 pl-2">
            <span>Always Use This Status</span>
            <v-chip label color="green lighten-3 ml-2">{{state.forceState? "Yes": "No"}}</v-chip>
          </v-chip>
        </div>
        <div class="ma-2">
          <v-chip label color="green lighten-4" class="pa-0 pl-2">
            <span>Reset Car Number</span>
            <v-chip label color="green lighten-3 ml-2">{{state.resetCarNumber? "Yes": "No"}}</v-chip>
          </v-chip>
        </div>
      </div>
    </div>
    <AFormDialog
      ref="stateFormDialog"
      :fields="formFields"
      :modelName="'Flow State'"
      :model="'flowstates'"
      :updateOnlyChanged="false"
      @modified="$emit('load')"
    ></AFormDialog>
  </div>
</template>

<script>
import axios from "../../../api/axios";
import ConfirmDialogMixin from "../../../mixins/ConfirmDialogMixin";
import crudFuncsMixin from "../../../mixins/CRUDFuncs";
// import AFormDialog from "../../../components/AFormDialog";

export default {
  name: "flownode",
  mixins: [ConfirmDialogMixin, crudFuncsMixin],
  props: ["node", "moveUp", "moveDown", "moveAction", "deleteAction"],
  data() {
    return {
      model: "flowstates"
    };
  },
  computed: {
    formFields: function() {
      return [
        {
          type: "silent",
          silent: true,
          queryParam: "flowNodeId",
          defaultValue: this.node.id
        },
        {
          type: "dropdown",
          model: "locations",
          label: "Location*",
          queryParam: "locationId",
          updatable: true,
          rules: [v => v !== undefined || "This is field is mandatory"]
        },
        {
          type: "dropdown",
          model: "states",
          label: "Status*",
          queryParam: "stateId",
          updatable: true,
          rules: [v => v !== undefined || "This is field is mandatory"]
        },
        {
          type: "checkbox",
          label: "Always use this status",
          queryParam: "forceState",
          updatable: true
        },
        {
          type: "checkbox",
          label: "Reset Car Number",
          queryParam: "resetCarNumber",
          updatable: true
        }
      ];
    }
  },
  beforeCreate() {
    // lazy load this component to avoid 'recursive error'
    this.$options.components.AFormDialog = require("../../../components/AFormDialog.vue").default;
  },
  methods: {
    load: async function() {
      this.$emit("load");
      // this.$parent.load()
      // console.log('load function')
      // try {
      //   const res = await axios.get("/flowstates?flowNodeId=" + this.node.id);
      //   console.log(res)
      //   if(res.data.d.ok) {
      //     this.node.flowStates = res.data.d.items
      //   } else {
      //     console.log(res)
      //   }
      // } catch(err) {
      //   console.log(err)
      // }
    }
  }
};
</script>